import React from 'react';
import { useEffect } from "react";
import Navigation from './navigation'; // Import navigation jsx


function App() {
  useEffect(() => {
  const videos = document.querySelectorAll("video");

  videos.forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
  });
}, []);
  return (
    <div className="App">
    <Navigation />
    </div>
  );
}

export default App;
